import { OrderDataTabMessages } from "@/messages/order-form-page/order-data-tab.messages";
import { OrderStatus } from "@/types/order.types";

export const ORDER_STATUS_TRANSLATION = (messages: OrderDataTabMessages) => ({
  [OrderStatus.Confirmed]: messages.confirmed,
  [OrderStatus.Paid]: messages.paid,
  [OrderStatus.Handling]: messages.handling,
  [OrderStatus.Invoiced]: messages.invoiced,
  [OrderStatus.Shipped]: messages.shipped,
  [OrderStatus.Delivered]: messages.delivered,
  [OrderStatus.Waiting]: messages.waiting,
  [OrderStatus.Cancelled]: messages.cancelled,
  [OrderStatus.CancellationRequest]: messages.cancellationRequest,
  [OrderStatus.Error]: messages.error,
});

export const STATUS_OPTIONS = (
  messages: OrderDataTabMessages,
  isEditing: boolean,
  currentStatus: OrderStatus,
  previousStatus: OrderStatus | null
) => {
  const labels: { [key in OrderStatus]: string } = ORDER_STATUS_TRANSLATION(messages);

  // Opcionalmente listamos todos, mas filtraremos estritamente pelo status atual
  let statusOptions: OrderStatus[] = [
    OrderStatus.Confirmed,
    OrderStatus.Paid,
    OrderStatus.Handling,
    OrderStatus.Invoiced,
    OrderStatus.Shipped,
    OrderStatus.Delivered,
    OrderStatus.Cancelled,
    OrderStatus.Error,
  ];

  if (!isEditing) {
    return statusOptions.map((status) => ({
      value: status,
      label: labels[status],
    }));
  }

  // Em modo de edição, mantemos o status atual disponível; demais serão filtrados pelas regras
  statusOptions = [currentStatus, ...statusOptions];

  const filteredOptions = statusOptions.filter((status) => {
    switch (currentStatus) {
      case OrderStatus.Waiting:
        // Waiting → Confirmed, Error, Paid ou Cancelled
        return [
          OrderStatus.Confirmed,
          OrderStatus.Error,
          OrderStatus.Paid,
          OrderStatus.Cancelled,
        ].includes(status);
      case OrderStatus.Error:
        // Error → Confirmed, Paid ou Cancelled
        return [OrderStatus.Confirmed, OrderStatus.Paid, OrderStatus.Cancelled].includes(status);
      case OrderStatus.Paid:
        // Paid → Handling, Invoiced, Shipped, Delivered ou Cancelled
        return [
          OrderStatus.Handling,
          OrderStatus.Invoiced,
          OrderStatus.Shipped,
          OrderStatus.Delivered,
          OrderStatus.Cancelled,
        ].includes(status);
      case OrderStatus.Handling:
        // Handling → Invoiced, Shipped, Delivered, Cancelled
        return [OrderStatus.Invoiced, OrderStatus.Shipped, OrderStatus.Delivered, OrderStatus.Cancelled].includes(
          status
        );
      case OrderStatus.Invoiced:
        // Invoiced → Shipped, Delivered, Cancelled
        return [OrderStatus.Shipped, OrderStatus.Delivered, OrderStatus.Cancelled].includes(status);
      case OrderStatus.Shipped:
        // Shipped → Delivered, Cancelled
        return [OrderStatus.Delivered, OrderStatus.Cancelled].includes(status);
      case OrderStatus.Confirmed:
        // Confirmed → Paid ou Cancelled
        return [OrderStatus.Paid, OrderStatus.Cancelled].includes(status);
      case OrderStatus.CancellationRequest:
        // Não permitir seleção de CR manualmente
        return false;
      case OrderStatus.Delivered:
        // Delivered é final (tratado abaixo), mas aqui garantimos que não haja transição
        return false;
      case OrderStatus.Cancelled:
        // Cancelled é final (tratado abaixo), mas aqui garantimos que não haja transição
        return false;
      default:
        return false;
    }
  });

  // Garantir que o status atual esteja sempre incluído
  if (!filteredOptions.includes(currentStatus)) {
    filteredOptions.unshift(currentStatus);
  }

  return filteredOptions.map((status) => ({
    value: status,
    label: labels[status],
  }));
};

export const isFinalStatus = (orderStatus: OrderStatus): boolean => {
  return orderStatus === OrderStatus.Cancelled || orderStatus === OrderStatus.Delivered;
};
